

























import { Component, Vue } from 'vue-property-decorator';
import { ReleaseNote } from '@/classes/ReleaseNote';
import { momentDateFormatter } from '@/services/inputTools';

@Component
export default class Home extends Vue {
    public get releaseNotes(): ReleaseNote[] {
        const releaseNotes: ReleaseNote[] | undefined = this.$store.getters['notifications/getCurrentReleaseNotes'];
        if (releaseNotes !== undefined) {
            return releaseNotes.sort((releaseA: ReleaseNote, releaseB: ReleaseNote) => {
                return releaseB.publishDateTimeAsNumber - releaseA.publishDateTimeAsNumber;
            });
        } else {
            return [];
        }
    }

    public get metaString(): string {
        const metaString: string | undefined = this.$store.getters['meta/getMetaString'];
        if (metaString !== undefined) {
            return metaString;
        } else {
            return '';
        }
    }

    public cardTitle(card: ReleaseNote): string {
        return card.subject + ' - ' + momentDateFormatter(card.publishDateTime);
    }
}
